import React, { forwardRef, useContext } from "react";
import { Button, Col, Form, Row } from "reactstrap";
import SikkaInput from "../../common/SikkaInput";
import { useForm } from "react-hook-form";
import APICall from "../../../services/apiCall";
import AppContext from "../../../context/Context";
import { toast } from "react-toastify";
import { CapitalizeString } from "../../auth/payment/RegisterPayment";

const hostName = (url) => {
  if (url.includes("localhost")) {
    return "localhost";
  } else if (url.includes("qa")) {
    return "qa";
  } else {
    return "production";
  }
};

const AddAchPaymentForm = ({
  defaultActiveKey,
  setError,
  errors,
  register,
  clearError,
  setValue,
  formRef,
}) => {
  const { loginUserDetails } = useContext(AppContext);

  return (
    <>
      <Form id={`${defaultActiveKey}-hook-form`} ref={formRef}>
        <Row>
          <Col>
            <SikkaInput
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(e.target.name, e.target.value.trim());
                }
              }}
              label="Account Name*"
              placeholder="Account Name"
              id="account_name"
              name={`${defaultActiveKey}_name_on_account`}
              innerRef={register({
                required: "Account name is required",
                validate: (value) => {
                  return (
                    value.length <= 22 ||
                    "The account name should not exceed 22 characters."
                  );
                },
              })}
              errors={errors}
            />
          </Col>
          <Col>
            <SikkaInput
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(e.target.name, e.target.value.trim());
                }
              }}
              label="Bank Name*"
              placeholder="Bank Name"
              id="bankName"
              name={`${defaultActiveKey}_bank_name`}
              innerRef={register({
                required: "Bank Name is required",
              })}
              errors={errors}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <SikkaInput
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(e.target.name, e.target.value.trim());
                }
              }}
              label="Account Number*"
              name={`${defaultActiveKey}_account_number`}
              id="accountNumber"
              type="number"
              placeholder="Account Number"
              innerRef={register({
                required: "Account Number is required",
                validate: (value) => {
                  return (
                    `${value}`.length <= 17 ||
                    "The account number should not exceed 17 digits."
                  );
                },
              })}
              errors={errors}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <SikkaInput
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(e.target.name, e.target.value.trim());
                }
              }}
              label="Routing Number*"
              name={`${defaultActiveKey}_routing_number`}
              type="number"
              id="routingNumber"
              placeholder="Routing Number"
              innerRef={register({
                required: "Routing Number is required",
                validate: (value) => {
                  return (
                    `${value}`.length <= 9 ||
                    "The routing number should not exceed 9 digits."
                  );
                },
              })}
              errors={errors}
            />
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default forwardRef(AddAchPaymentForm);
